import moment from "moment/moment";
import React from "react";
import { Link } from "react-router-dom";
import { Col, Button } from "reactstrap";
import { baseURL } from "../Axios";
import icon from "../assets/img/placeholder.png";

const MailboxUser = ({
  id,
  profileId,
  image,
  name,
  gender,
  dob,
  state,
  district,
  status,
  email,
  countryCode,
  phone,
  deletedReason,
  taluk,
  profileCompletenes,
  education,
  occupation,
  maritalStatus,
  fatherStatus,
  motherStatus,
  horoscope,

  employedIn,

  monthlyIncome,
  kulam,
  dhosam,

  location,

  onDelete,
  onActive,
  errorButtonText = "Inactive",
}) => {
  const calculateAge = (dob) => {
    const birthDate = moment(dob, ["DD-MM-YYYY", "YYYY-MM-DD"]);
    if (!birthDate.isValid()) return { years: "-", months: "-" };
    const today = moment();
    const years = today.diff(birthDate, "years");
    birthDate.add(years, "years");
    const months = today.diff(birthDate, "months");
    return { years, months };
  };

  const { years, months } = calculateAge(dob);

  return (
    <Col xs={12} md={12} lg={12}>
      <div
        className="card"
        style={{
          width: "100%",
          padding: "20px",
          marginBottom: "24px",
          border: "1px solid #dcdcdc",
          borderRadius: "12px",
          background: "#fff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        }}
      >
        {/* Age info */}
        <span
          style={{
            marginLeft: "10px",
            fontSize: "12px",
            fontWeight: 600,
            color: "#4caf50",
            background: "#e6f4ea",
            padding: "2px 8px",
            borderRadius: "6px",
          }}
        >
          {profileId}
        </span>
        {/* Profile Image & Details */}
        <div
          style={{
            gap: "16px",
            borderBottom: "1px solid #f2f2f2",
            paddingBottom: "16px",
            marginBottom: "16px",
          }}
        >
          <img
            src={image ? baseURL + image : icon}
            alt="Profile"
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "8px",
              objectFit: "cover",
              border: "1px solid #eee",
              background: "#fafafa",
              flexShrink: 0,
            }}
          />
          <div>
            <div style={{ marginBottom: "8px" }}>
              <h5
                style={{
                  fontWeight: 700,
                  fontSize: "18px",
                  color: "#222",
                  marginBottom: "4px",
                }}
              >
                {name}
              </h5>
            </div>

            <ul
              style={{
                listStyle: "none",
                paddingLeft: 0,
                marginBottom: 0,
                fontSize: "14px",
                color: "#555",
                lineHeight: "1.7",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              {dob && years !== "-" && months !== "-" && (
                <li style={{ display: "flex" }}>
                  <strong style={{ width: "120px" }}>DOB:</strong>
                  <span>
                    {dob} / {years} yrs
                  </span>
                </li>
              )}

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Gender:</strong>
                <span style={{ textTransform: "capitalize" }}>{gender}</span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Email:</strong>
                <span>{email}</span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Phone:</strong>
                <span>
                  {countryCode} {phone}
                </span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Education:</strong>
                <span>{education}</span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Job Type:</strong>
                <span>{employedIn}</span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Occupation:</strong>
                <span>{occupation}</span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Salary:</strong>
                <span>{monthlyIncome}</span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Kulam:</strong>
                <span>{kulam}</span>
              </li>

              <li style={{ display: "flex" }}>
                <strong style={{ width: "120px" }}>Dhosam:</strong>
                <span>{dhosam}</span>
              </li>

              {status === "terminated" ? (
                <li style={{ display: "flex", color: "#d9534f" }}>
                  <strong style={{ width: "120px" }}>Reason:</strong>
                  <span>{deletedReason}</span>
                </li>
              ) : (
                <li style={{ display: "flex" }}>
                  <strong style={{ width: "120px" }}>Location:</strong>
                  <span>
                    {[taluk, district, state].filter(Boolean).join(", ")}
                  </span>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <Link
            to={`/dashboard1/${id}`}
            className="btn"
            style={{
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid #dee2e6",
              background: "#f6f8fa",
              color: "#333",
              borderRadius: "5px",
              padding: "6px 18px",
            }}
          >
            <i className="bi bi-eye-fill"></i> View
          </Link>
        </div>
      </div>
    </Col>
  );
};

export default MailboxUser;
